import IntakeViaChip from './IntakeViaChip.component';

export default IntakeViaChip;
